// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Cocdashboard_dashboard__Izisw {
    display: flex;
    height: 100vh;
  }
  
  .Cocdashboard_sidebar__xRsmx {
    width: 200px; 
    background-color: #f5f5f5;
    padding: 20px;
    display: flex;
    flex-direction: column;
    box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1); /* Sidebar shadow */
  }
  
  .Cocdashboard_sidebarHeader__Qgd5R {
    font-size: 1.5rem;
    font-weight: bold;
    /* margin-bottom: 10px; */
    text-align: center;
    color: #333;
    border-bottom: 2px solid #ccc; /* Border below MeBot name */
    padding-bottom: 10px;
  }
  
  .Cocdashboard_botList__NcmPj {
    flex: 1 1;
    padding: 0;
    text-align: center;
    overflow-y: auto;
    /* border-bottom: 2px solid #ccc; Border below item list */
  }
  
  .Cocdashboard_botListItem__xoQ3i {
    padding: 5px;
    margin-bottom: 5px;
    border-radius: 5px;
    transition: background-color 0.3s ease, color 0.3s ease;
    cursor: pointer;
  }
  
  .Cocdashboard_botListItem__xoQ3i:hover {
    background-color: #f0f0f0;
  }
  
  .Cocdashboard_selectedBot__0L7pa {
    background-color: #727377 !important;
    color: white !important;
    font-weight: bold;
  }
  
  .Cocdashboard_createBotButton__bzmUy {
    margin-top: 10px !important;
    width: 100%;
    color: white;
    border: none;
    text-transform: none !important;
    padding: 12px;
    border-radius: 5px !important;
    transition: background-color 0.3s ease;
  }

  
  .Cocdashboard_createBotButton__bzmUy:hover {
    background-color: #49494b;
    color: #fff;
    cursor: pointer;
  }

  .Cocdashboard_uploadFileButton__r-JNQ {
    width: 100%;
    color: white;
    border: none;
    text-transform: none !important;
    padding: 12px;
    border-radius: 5px !important;
    transition: background-color 0.3s ease;
  }

  .Cocdashboard_uploadFileButton__r-JNQ:hover {
    background-color: #49494b;
    color: #fff;
    cursor: pointer;
  }
  
  .Cocdashboard_mainContent__NR4C8 {
    flex: 1 1;
    display: flex;
    justify-content: center; /* Align content to the left */
    align-items: stretch; /* Stretch the content to fill the height */
    background-color: #ffffff;
    padding: 0; /* Remove padding to make chat page fill space */
  }
  
  .Cocdashboard_chatPageWrapper__\\+PgTJ {
    display: flex;
    flex-direction: column; /* Allow chat page content to be stacked */
    flex: 1 1;
    height: 100%; /* Full height */
    width: 100%; /* Full width */
    /* padding: 20px; */
    background-color: #eaeaea;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
  
  .Cocdashboard_rightIcons__mxrow {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding: 20px;
    background-color: #f5f5f5;
    border-left: 1px solid #ddd;
    border-radius: 5px;
    flex-shrink: 0; /* Prevent shrinking */
  }
  
  .Cocdashboard_iconButton__Y\\+7o0 {
    margin: 10px 0;
  }
  
  .Cocdashboard_placeholder__l2TDE {
    text-align: center;
    color: #666;
    font-size: 1.2rem;
  }
  
  .Cocdashboard_placeholder__l2TDE h2 {
    font-size: 2rem;
    margin-bottom: 20px;
  }
  
  .Cocdashboard_topBar__bdru0 {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 15px 20px;
    background-color: #f5f5f5;
    border-bottom: 1px solid #ddd;
  }
  
  .Cocdashboard_icon__OuY3r {
    width: 25px; /* Adjust size */
    height: 25px;
    margin-left: 10px;
    cursor: pointer;
    transition: transform 0.2s ease-in-out;
  }
  
  .Cocdashboard_icon__OuY3r:hover {
    transform: scale(1.1); /* Slightly enlarge on hover */
  }
  

/* Popup Overlay */
.Cocdashboard_popupOverlay__hIWap {
  position: fixed;
  top: 0;
  left: 0;
  text-align: left;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

/* Popup */
.Cocdashboard_popup__zF3Fq {
  background: #fff;
  width: 400px;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

/* Close Button */
.Cocdashboard_closeButton__mPE6S {
  position: absolute;
  top: 5px;
  right: 5px;
  background: none;
  border: none;
  font-size: 30px;
  cursor: pointer;
}

/* Form Group */
.Cocdashboard_formGroup__TCeQD {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.Cocdashboard_formGroup__TCeQD label {
  font-size: 14px;
  font-weight: 600;
}

.Cocdashboard_formGroup__TCeQD input,
.Cocdashboard_formGroup__TCeQD textarea {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

textarea.Cocdashboard_readOnlyMessage__TwqSh {
  resize: none;
  height: 200px;
  background-color: #f9f9f9;
  color: #555;
  border: 1px solid #ddd;
  cursor: not-allowed;
}

.Cocdashboard_sendButton__a\\+HHo:hover {
  background-color: #49494b;
  color: #fff;
  cursor: pointer;
}

.Cocdashboard_statusMessage__4nhcl {
  margin-top: 10px;
  font-size: 14px;
  text-align: center;
}
.Cocdashboard_success__2KQVZ {
  color: green;
}
.Cocdashboard_error__SvZyy {
  color: red;
}
`, "",{"version":3,"sources":["webpack://./src/component/dashboard/chat/codeofconduct/Cocdashboard.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,wCAAwC,EAAE,mBAAmB;EAC/D;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,6BAA6B,EAAE,4BAA4B;IAC3D,oBAAoB;EACtB;;EAEA;IACE,SAAO;IACP,UAAU;IACV,kBAAkB;IAClB,gBAAgB;IAChB,0DAA0D;EAC5D;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,uDAAuD;IACvD,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,oCAAoC;IACpC,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,+BAA+B;IAC/B,aAAa;IACb,6BAA6B;IAC7B,sCAAsC;EACxC;;;EAGA;IACE,yBAAyB;IACzB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,+BAA+B;IAC/B,aAAa;IACb,6BAA6B;IAC7B,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,SAAO;IACP,aAAa;IACb,uBAAuB,EAAE,8BAA8B;IACvD,oBAAoB,EAAE,2CAA2C;IACjE,yBAAyB;IACzB,UAAU,EAAE,gDAAgD;EAC9D;;EAEA;IACE,aAAa;IACb,sBAAsB,EAAE,0CAA0C;IAClE,SAAO;IACP,YAAY,EAAE,gBAAgB;IAC9B,WAAW,EAAE,eAAe;IAC5B,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,wCAAwC;EAC1C;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,2BAA2B;IAC3B,kBAAkB;IAClB,cAAc,EAAE,sBAAsB;EACxC;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,6BAA6B;EAC/B;;EAEA;IACE,WAAW,EAAE,gBAAgB;IAC7B,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,qBAAqB,EAAE,8BAA8B;EACvD;;;AAGF,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA,UAAU;AACV;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,4CAA4C;EAC5C,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ","sourcesContent":[".dashboard {\n    display: flex;\n    height: 100vh;\n  }\n  \n  .sidebar {\n    width: 200px; \n    background-color: #f5f5f5;\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n    box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1); /* Sidebar shadow */\n  }\n  \n  .sidebarHeader {\n    font-size: 1.5rem;\n    font-weight: bold;\n    /* margin-bottom: 10px; */\n    text-align: center;\n    color: #333;\n    border-bottom: 2px solid #ccc; /* Border below MeBot name */\n    padding-bottom: 10px;\n  }\n  \n  .botList {\n    flex: 1;\n    padding: 0;\n    text-align: center;\n    overflow-y: auto;\n    /* border-bottom: 2px solid #ccc; Border below item list */\n  }\n  \n  .botListItem {\n    padding: 5px;\n    margin-bottom: 5px;\n    border-radius: 5px;\n    transition: background-color 0.3s ease, color 0.3s ease;\n    cursor: pointer;\n  }\n  \n  .botListItem:hover {\n    background-color: #f0f0f0;\n  }\n  \n  .selectedBot {\n    background-color: #727377 !important;\n    color: white !important;\n    font-weight: bold;\n  }\n  \n  .createBotButton {\n    margin-top: 10px !important;\n    width: 100%;\n    color: white;\n    border: none;\n    text-transform: none !important;\n    padding: 12px;\n    border-radius: 5px !important;\n    transition: background-color 0.3s ease;\n  }\n\n  \n  .createBotButton:hover {\n    background-color: #49494b;\n    color: #fff;\n    cursor: pointer;\n  }\n\n  .uploadFileButton {\n    width: 100%;\n    color: white;\n    border: none;\n    text-transform: none !important;\n    padding: 12px;\n    border-radius: 5px !important;\n    transition: background-color 0.3s ease;\n  }\n\n  .uploadFileButton:hover {\n    background-color: #49494b;\n    color: #fff;\n    cursor: pointer;\n  }\n  \n  .mainContent {\n    flex: 1;\n    display: flex;\n    justify-content: center; /* Align content to the left */\n    align-items: stretch; /* Stretch the content to fill the height */\n    background-color: #ffffff;\n    padding: 0; /* Remove padding to make chat page fill space */\n  }\n  \n  .chatPageWrapper {\n    display: flex;\n    flex-direction: column; /* Allow chat page content to be stacked */\n    flex: 1;\n    height: 100%; /* Full height */\n    width: 100%; /* Full width */\n    /* padding: 20px; */\n    background-color: #eaeaea;\n    border-radius: 8px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  }\n  \n  .rightIcons {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n    padding: 20px;\n    background-color: #f5f5f5;\n    border-left: 1px solid #ddd;\n    border-radius: 5px;\n    flex-shrink: 0; /* Prevent shrinking */\n  }\n  \n  .iconButton {\n    margin: 10px 0;\n  }\n  \n  .placeholder {\n    text-align: center;\n    color: #666;\n    font-size: 1.2rem;\n  }\n  \n  .placeholder h2 {\n    font-size: 2rem;\n    margin-bottom: 20px;\n  }\n  \n  .topBar {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    padding: 15px 20px;\n    background-color: #f5f5f5;\n    border-bottom: 1px solid #ddd;\n  }\n  \n  .icon {\n    width: 25px; /* Adjust size */\n    height: 25px;\n    margin-left: 10px;\n    cursor: pointer;\n    transition: transform 0.2s ease-in-out;\n  }\n  \n  .icon:hover {\n    transform: scale(1.1); /* Slightly enlarge on hover */\n  }\n  \n\n/* Popup Overlay */\n.popupOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  text-align: left;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n/* Popup */\n.popup {\n  background: #fff;\n  width: 400px;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n/* Close Button */\n.closeButton {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  background: none;\n  border: none;\n  font-size: 30px;\n  cursor: pointer;\n}\n\n/* Form Group */\n.formGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.formGroup label {\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.formGroup input,\n.formGroup textarea {\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n}\n\ntextarea.readOnlyMessage {\n  resize: none;\n  height: 200px;\n  background-color: #f9f9f9;\n  color: #555;\n  border: 1px solid #ddd;\n  cursor: not-allowed;\n}\n\n.sendButton:hover {\n  background-color: #49494b;\n  color: #fff;\n  cursor: pointer;\n}\n\n.statusMessage {\n  margin-top: 10px;\n  font-size: 14px;\n  text-align: center;\n}\n.success {\n  color: green;\n}\n.error {\n  color: red;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `Cocdashboard_dashboard__Izisw`,
	"sidebar": `Cocdashboard_sidebar__xRsmx`,
	"sidebarHeader": `Cocdashboard_sidebarHeader__Qgd5R`,
	"botList": `Cocdashboard_botList__NcmPj`,
	"botListItem": `Cocdashboard_botListItem__xoQ3i`,
	"selectedBot": `Cocdashboard_selectedBot__0L7pa`,
	"createBotButton": `Cocdashboard_createBotButton__bzmUy`,
	"uploadFileButton": `Cocdashboard_uploadFileButton__r-JNQ`,
	"mainContent": `Cocdashboard_mainContent__NR4C8`,
	"chatPageWrapper": `Cocdashboard_chatPageWrapper__+PgTJ`,
	"rightIcons": `Cocdashboard_rightIcons__mxrow`,
	"iconButton": `Cocdashboard_iconButton__Y+7o0`,
	"placeholder": `Cocdashboard_placeholder__l2TDE`,
	"topBar": `Cocdashboard_topBar__bdru0`,
	"icon": `Cocdashboard_icon__OuY3r`,
	"popupOverlay": `Cocdashboard_popupOverlay__hIWap`,
	"popup": `Cocdashboard_popup__zF3Fq`,
	"closeButton": `Cocdashboard_closeButton__mPE6S`,
	"formGroup": `Cocdashboard_formGroup__TCeQD`,
	"readOnlyMessage": `Cocdashboard_readOnlyMessage__TwqSh`,
	"sendButton": `Cocdashboard_sendButton__a+HHo`,
	"statusMessage": `Cocdashboard_statusMessage__4nhcl`,
	"success": `Cocdashboard_success__2KQVZ`,
	"error": `Cocdashboard_error__SvZyy`
};
export default ___CSS_LOADER_EXPORT___;
